import { render, staticRenderFns } from "./store-grade.vue?vue&type=template&id=74f2f178&scoped=true"
import script from "./store-grade.vue?vue&type=script&lang=js"
export * from "./store-grade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f2f178",
  null
  
)

export default component.exports